
import Bookmarks from './components/bookmarks'

export default {
  name: 'BookmarkApp',
  components: {
    Bookmarks
  }
}
